/*
 * Funcionalidades del LMS que dependen de endpoints V2 del backend.
 *
 * Cada flag tiene un valor por defecto según lo que ya está desplegado en la API
 * (rama `master` de brainspro/app) y se puede forzar por entorno con
 * `VUE_APP_LMS_<NOMBRE>=true|false` (ver `.env.example`). El build de producción
 * no pasa estas variables, así que allí manda el valor por defecto.
 *
 * Vue CLI solo sustituye `process.env.VUE_APP_*` escritos literalmente, por eso
 * cada variable se lee por su nombre completo.
 */
const flag = (value, enabledByDefault) => (value === undefined || value === '' ? enabledByDefault : value === 'true')

export default {
    // FE-020 · Borrar secciones: LMS-060 desplegado (DELETE /v2/lms/courses/{curso}/sections/{sección}).
    deleteSection: flag(process.env.VUE_APP_LMS_DELETE_SECTION, true),
    // FE-020 · Borrar lecciones: LMS-062 desplegado (DELETE …/sections/{sección}/lessons/{lección}, app#47).
    deleteLesson: flag(process.env.VUE_APP_LMS_DELETE_LESSON, true),
    // FE-021 · Renombrar lecciones: LMS-062 desplegado (PUT …/lessons/{lección} con { title }, app#47).
    renameLesson: flag(process.env.VUE_APP_LMS_RENAME_LESSON, true),
    // FE-022 · Reordenar secciones y mover lecciones: LMS-061 y LMS-063 desplegados
    // (PUT …/sections/order y PUT …/curriculum, ambos con uuids; app#49 y app#50).
    reorderCurriculum: flag(process.env.VUE_APP_LMS_REORDER_CURRICULUM, true),
    // FE-023 · Publicar y despublicar secciones y lecciones: LMS-064 desplegado (app#51).
    publishCurriculum: flag(process.env.VUE_APP_LMS_PUBLISH_CURRICULUM, true),
    // FE-023 · Lección de vista previa gratuita: LMS-065 desplegado (app#52).
    freePreview: flag(process.env.VUE_APP_LMS_FREE_PREVIEW, true),

    // Editor de lección por bloques (FE-030): LMS-066, LMS-067 y LMS-074 desplegados
    // (/v2/lms/lessons/{lección}/blocks, app#102 y app#103). El tipo vídeo depende de
    // videoBlock.
    lessonBlocks: flag(process.env.VUE_APP_LMS_LESSON_BLOCKS, true),
    // Bloque de vídeo con subida a S3 y embeds (FE-031 · LMS-069, LMS-080, LMS-083).
    videoBlock: flag(process.env.VUE_APP_LMS_VIDEO_BLOCK, false),
    // Bloque de quiz con su editor de preguntas (FE-033 · LMS-072, LMS-090, LMS-091):
    // desplegado bajo /v2/lms/quizzes (app#123) y conectado en FE-067.
    quizBlock: flag(process.env.VUE_APP_LMS_QUIZ_BLOCK, true),
}
